<template>
  <mescroll-vue :up="getscrollData()" @init="initScroll" :down="mescrollDown">
    <div class="list" id="dataList">
      <div
        v-for="(item, index) in resourceData"
        :key="index"
        @click="intoResource(item)"
      >
        <search-cell :msg="item | formatData"></search-cell>
      </div>
    </div>
  </mescroll-vue>
</template>

<script>
import SearchCell from "./searchCell.vue";
import MescrollVue from "mescroll.js/mescroll.vue";
import pub_methods from "./mixins/pub_methods.js";
export default {
  name: "eleresources",
  mixins: [pub_methods],
  data() {
    return {
      resourceData: [],
    };
  },
  components: {
    SearchCell,
    MescrollVue,
  },
  methods: {
    upCallback(page, mescroll) {
      this.getDatas(page.num, page.size, mescroll);
    },
    // 获取数据
    getDatas(pageNum, pageSize, mescroll) {
      let _this = this;
      let url = "index.php/mobile/search/opt-resources-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        size: pageSize,
        page: pageNum,
        keyword: _this.$store.state.searchWord,
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          let data = res.data.result.data;
          if (pageNum == 1) {
            _this.resourceData = [];
          }
          _this.resourceData = _this.resourceData.concat(data);
          _this.$nextTick(() => {
            if (pageNum > res.data.result.pages.page_count) {
              mescroll.endSuccess(data.length, false);
            } else {
              mescroll.endSuccess(data.length, true);
            }
          });
        }
      });
    },
    intoResource(item) {
      this.$router.push({
        path: "/main/elective_lib/curricula_variable",
        query: { trainplan_id: item.trainplan_id },
      });
    },
  },
  filters: {
    formatData(item) {
      return {
        type: item.res_type,
        trainplan_name: item.trainplan_name,
        name: item.resources_name,
        trainplan_type: 1,
      };
    },
  },
};
</script>

<style lang="less" scoped>
#dataList {
  /deep/.mescroll-empty {
    height: 90vh;
    background: #fff;
    .empty-icon {
      margin: 1rem auto 0;
    }
  }
}
</style>
